class CustomEventHandler extends EventTarget {
  subscribe(eventName, cb) {
    if (!_.has(window, eventName)) {
      window[eventName] = cb;
      window.removeEventListener(eventName, cb);
      window.addEventListener(eventName, cb);
    }
  }

  emit(eventName, payload = null) {
    window.dispatchEvent(new CustomEvent(eventName, { detail: payload }));
  }

  toChildren(pk, fields = []) {
    fields.forEach((ck) => {
      this.emit(`${window.tabID}::formula::event::${pk}_${ck}`);
    });
  }

  unsubscribe(eventName) {
    window.removeEventListener(eventName, window[eventName]);
    delete window[eventName];
  }
}

export const EventHandler = new CustomEventHandler();
